<template lang="html">
  <div>
    <v-row class="pb-4">
      <v-col>
        <span class="title">Leave Approval and Authority</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-tabs
          v-model="tabSelected"
          class="elevation-3"
          icons-and-text
          grow
        >
          <v-tab
            v-for="(tab,i) in tabs"
            :key="i"
          >
            {{ tab.text }}
            <v-icon>{{ tab.icon }}</v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items 
          v-model="tabSelected"
          class="elevation-3"
        >
          <div
            v-show="isTabOne"
          >
            <setup-positions-approvals-levels-leave-form-update
              :position="position"
              @close-dialog="closeDialog"
            />
          </div>

          <div v-show="isTabTwo">
            <setup-positions-approvals-authorities-leave-form-update
              :position="position"
              @close-dialog="closeDialog"
            />
          </div>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    components: {
      SetupPositionsApprovalsLevelsLeaveFormUpdate: () => import('@/components/setup/positions/approvals/levels/LeaveFormUpdate'),
      SetupPositionsApprovalsAuthoritiesLeaveFormUpdate: () => import('@/components/setup/positions/approvals/authorities/LeaveFormUpdate'),
    },
    props: {
      position: { 
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        tabSelected: 0,
        tabs: [
          { text: 'Approval Requirement', icon: 'mdi-account-multiple-plus' },
          { text: 'Authorize Leave', icon: 'mdi-account-check-outline' },
        ],
      }
    },
    computed: {
      isTabOne () {
        return this.tabSelected === 0
      },
      isTabTwo () {
        return this.tabSelected === 1
      },
    },
    methods: {
      closeDialog () {
        this.$emit('close-dialog')
      },
    },
  }
</script>

<style lang='css' scoped>
</style>
